<svelte:options accessors/>
<script lang="ts">
    import NauiExplorer from "../naui/pages/NauiExplorer.svelte";
    import NauiButton from "../naui/atoms/NauiButton.svelte"
    import Flatpickr from 'svelte-flatpickr';
    import 'flatpickr/dist/flatpickr.css';
    import NauiSlideOver from "../naui/layout/NauiSlideOver.svelte";
    import NauiCheckboxGroup from "../naui/atoms/NauiCheckboxGroup.svelte";
    import NauiCheckbox from "../naui/atoms/NauiCheckbox.svelte";
    import {onMount} from 'svelte';

    export let data;
    export let columns;
    export let editColumns = true;
    export let filters;
    export let actions;
    export let searchLabel;
    export let hideSearch = false;

    export let count;
    export let pages = 0;

    export let paginator = {
        total: pages,
        page: 1
    }

    let open = false;
    let explorerCmpt;

    export function getParams() {
        if (explorerCmpt) {
            return explorerCmpt.getParams();
        }
    }

    let value, formattedValue;

    const options = {
        enableTime: false,
        mode: 'range',
        dateFormat: "d/m/Y",
        conjunction: " :: ",
        onChange(selectedDates, dateStr, instance) {
        }
    };

    function handleChange(event) {
        const [selectedDates, dateStr] = event.detail;
    }

    function handleSubmit(event) {
        event.preventDefault();
    }

    function updateVisibility() {
        sessionStorage.setItem('columns', JSON.stringify(columns.map(c => ({slug: c.slug, show: c.show}))))
        open = false
    }


    onMount(async () => {
        const tmp = sessionStorage.getItem('columns')
        if (tmp) {
            try {
                const cs = JSON.parse(tmp);
                columns.forEach((c) => {
                    const find = cs.find(_ => _.slug === c.slug);
                    if (find) {
                        c.show = find.show;
                    }
                })
                columns = columns
            } catch (e) {
            }
        }
    });
</script>

<div>
    <NauiExplorer {data}
                  {columns}
                  {filters}
                  paginate={true}
                  {paginator}
                  {count}
                  {pages}
                  {searchLabel}
                  {hideSearch}
                  on:filter
                  on:next
                  bind:this={explorerCmpt}>
        <div slot="actions">
            <div class="flex">
                {#each actions as action}
                    <NauiButton href={action.href}
                                icon={action.icon}
                                caption={action.label}
                                mode="solid" color="accent"/>
                {/each}

            </div>
        </div>
        <div slot="table-actions">
            {#if editColumns}
                <NauiButton icon="th-list" color="primary" on:click={()=>open=true}/>
            {/if}
        </div>
    </NauiExplorer>
</div>
{#if editColumns}
    <NauiSlideOver bind:open={open} title="Seleccionar columnas">
        {#each columns as column}
            {#if column.selectable}
                <NauiCheckbox label={column.label} bind:value={column.show}/>
            {/if}
        {/each}
        <div slot="actions" class="box">
            <NauiButton caption="GUARDAR" color="accent" mode="outline" className="min-w-300px"
                        on:click={updateVisibility}/>
        </div>
    </NauiSlideOver>
{/if}

